"use client";
import Image from "next/image";
import { useState } from 'react';
import { avenirNextRegular, avenirNextMedium } from '@/styles/fonts';
import clsx from 'clsx';
import AccordionArrow from "@/app/components/accordionArrow";
import competitiveBenchmarking from '@/app/images/tour/competitve benchmarking.png';
import campaigns from '@/app/images/tour/campagins.png';
import publisherData from '@/app/images/tour/publisherdata.png';

const menuItems = [
  {
    title: "Competitive Benchmarking",
    content: `Identify key differences in a competitive set using side-by-side and overlay visualizations. Compare ad spend, share of voice,
      and other key metrics.
      <br /><br /> See how your competitor's spending strategy has evolved over time. Use
      the Compare tab to get side-by-side comparisons for up to 5 advertisers. View daily,
      weekly, monthly, or quarterly data on spend and trends.`,
    image: competitiveBenchmarking,
    alt: "Competitive Benchmarking",
  },
  {
    title: "Campaigns",
    content: `Big brand advertisers often have multiple products and ad campaigns. See ad campaigns by product and modify their strategy accordingly.`,
    image: campaigns,
    alt: "Campaigns",
  },
  {
    title: "Publisher Data",
    content: `Adbeat's Top Publisher tab shows you which publishers your competitors buy the most traffic from. Leverage this information
      to spend smarter by testing out publishers that have already been proven to work
      for the competition.`,
    image: publisherData,
    alt: "Publisher Data",
  },
];

export default function TourCompetitiveBenchmarking() {
  const [tab, setTab] = useState(0);
  const toggleTab = (index: number) => {
    setTab(tab === index ? -1 : index);
  };

  const liClassName = clsx(
    avenirNextRegular.className,
    "text-[16px]",
    "text-[#000000]",
    "mb-[20px]",
    "w-full",
    "border-t",
    "border-[#d8d8d8]"
  );
  const menuItemClassName = clsx(
    avenirNextMedium.className,
    "text-[22px]",
    "text-[#343f50]",
    "cursor-pointer",
    "pt-[36px]",
    "pb-[8px]",
    "sm:py-[40px]",
    "pl-[15px]",
    "flex justify-between",
  );
  const itemClassName = clsx(
    "text-[#5e6977]",
    "text-[18px]",
    "pl-[15px]",
    "sm:pb-[40px]",
    "leading-[1.8]",
    "transition-all",
    "duration-500"
  );

  return (
    <section className={clsx(
      "w-full",
      "text-[18px]",
      "text-[#5e6977]",
      avenirNextRegular.className,
      "grid",
      "pt-[15px] sm:pt-[80px]",
      "pb-[80px]",
      "text-left",
      "xs:grid-cols-1",
      "lg:grid-cols-[minmax(0,1fr)_minmax(0,400px)_minmax(0,400px)_minmax(0,1fr)]",
      "lg:gap-x-[40px]",
      "lg:items-start",
      "gap-[20px]",
      "overflow-visible")}>
      <div className="lg:col-start-2 lg:col-end-3">
        <h2 className={clsx(
          avenirNextMedium.className,
          "text-[20px] sm:text-[30px]",
          "px-[15px]",
          "text-[#444847]",
          "pb-[17px] sm:pb-[40px]",
        )}>Competitive Monitoring</h2>
        <ul className="sm:px-[15px]">
          {menuItems.map((item, index) => (
            <li key={index} className={liClassName}>
              <div className={menuItemClassName} onClick={() => toggleTab(index)}>
                <div>{item.title}</div>
                <AccordionArrow direction={tab === index ? "down" : "right"} />
              </div>
              <div className={clsx(itemClassName)} style={{
                maxHeight: tab === index ? "1000px" : "0",
                opacity: tab === index ? 1 : 0,
                paddingBottom: tab === index ? "20px" : "0",
                pointerEvents: tab === index ? "auto" : "none",
              }}>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-[20px] items-start w-full">
                  <div dangerouslySetInnerHTML={{ __html: item.content }} className="pr-[15px] leading-[1.1]" />
                  <div className="w-full flex justify-end mr-[-50px] sm:mr-0 lg:hidden">
                    <Image
                      src={item.image}
                      alt={item.alt}
                      className="img-responsive accordian-img w-1/2 sm:w-full h-auto"
                    />
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {/* Right column: active item image, lg+ only */}
      <div className="hidden lg:flex lg:col-start-4 lg:col-end-5 lg:items-start lg:justify-end lg:pt-[20px]">
        {tab >= 0 && (
          <Image
            src={menuItems[tab].image}
            alt={menuItems[tab].alt}
            className="w-full h-auto md:min-w-[400px]"
          />
        )}
      </div>
    </section>
  );
}

